
import discussion from "@/components/discussion.vue";
import browse from "@/components/Discussion/browse.vue";
import recommend from "@/components/Discussion/recommend.vue";
import noContent from "@/components/noContent.vue";
import { trackLoginImpression } from '@/plugins/hwtag/events';

export default {
  components: { discussion, browse, recommend },
  name: "index",
  head() {
    // 优化seo：动态设置title，keywords 和 description
    return {
      title: "Discussion",
      meta: [
        {
          name: "keywords",
          content: "xppen-xfans-discussion",
        },
        {
          name: "description",
          content: "users can post and discuss here",
        },
      ],
    };
  },
  data() {
    return {
      asyncSource: [],
      total: "", //总页数
      pageSize: 20, //每页显示条目个数
      currentPage: parseInt(this.$route.query.page) || 1, //当前页
      order_type: this.$route.query.order_type || 2, //1最热 2最新
      browseData: [],
    };
  },
  async asyncData({ $global, query, error }) {
    let asyncSource = [];
    let total = 0;
    let browseData = [];
    let recommend = [];
    try {
        const res = await $global.forumList({
          page: query.page == undefined ? 1 : query.page,
          order_type: query.order_type == undefined ? 2 : query.order_type,
        });
        if (res.code == 200) {
          asyncSource = res.data.postsList.data;
          total = res.data.postsList.total;
          browseData = res.data.top_posts;
          recommend = res.data.hits_posts;
        }
    } catch (e) {}
    return { asyncSource, total, browseData, recommend };
  },
  watchQuery: ["page", "order_type"],
  mounted() {
    console.log(this.$route);
  },
  methods: {
    handleCurrentChange(val) {
      this.$router.push({
        url: "/gallery",
        query: { page: val, order_type: this.$route.query.order_type || 2 },
      });
    },
    async getData() {
      const res = await this.$global.forumList({
        page: this.$route.query.page == undefined ? 1 : this.$route.query.page,
        order_type:
          this.$route.query.order_type == undefined ? 2 : this.$route.query.order_type,
      });
      if (res.code == 200) {
        this.asyncSource = res.data.postsList.data;
        this.total = res.data.postsList.total;
        this.browseData = res.data.top_posts;
      }
    },
    jumpEditor() {
      //没登录跳转登录页面
      const token = this.$cookies.get("SSOTOKEN");
      console.log(token, "token");
      if (!token || token === "undefined") {
        trackLoginImpression('点击', '发布帖子', 'Create a post');
        this.$message({
          message: this.$t('page.PLEASE_LOG_IN_TO_OPERATE'),
          type: "warning",
        });
        setTimeout(() => {
          const useNewLogin = this.$store.state.siteConfig && this.$store.state.siteConfig.DialogPassportSwitch == '1';
          if (useNewLogin) {
            this.$store.commit('OPEN_AUTH_MODAL', {
              tab: 'login',
              redirectToUserCenter: false,
              source: {
                elementTypeName: '发布帖子',
                clickName: 'Create a post',
              },
            });
          } else {
            this.$jumpTerminus(1);
          }
        }, 800);
      } else {
        let routeData = this.$router.resolve({ path: "/discussion/editor" });
        window.open(routeData.href, "_self");
      }
    },
  },
};
